import Alerts from '@rover/utilities/Alerts';
import ScrollTrigger from '@rover/utilities/scroll';

import $ from '@rover/globals/jquery';
import _ from '@rover/globals/underscore';
import Rover from '@rover/globals/Rover';
import dataLayer from '@rover/globals/dataLayer';

import currentUser from '@rover/globals/currentUser';
import i18n from '@rover/utilities/translation';
import { t } from '@lingui/macro';
import { isMobileEmbedded } from '@rover/utilities/userAgent';
import fireEmbeddedWebEvent from '@rover/utilities/fireEmbeddedWebEvent';

import { mount as mountConversationsCheckoutPage } from '@rover/react-lib/pages/conversations/ConversationsCheckoutPage';

import ConversationModel from '../models/conversation';
import CreditCardCollectionView from '../backbone/views/checkout/credit_card_collection_view';
import OptionalRequesterAddOnsListView from '../backbone/views/checkout/optional_requester_addons_list_view';
import ConfirmationView from '../backbone/views/checkout/confirmation_view';
import ConversationView from '../backbone/views/checkout/conversation_view';
import CreditCardCollection from '../backbone/models/CreditCardCollection';
import RecurringBillingSummaryView from '../backbone/views/checkout/recurring_billing_summary_view';
import RedemptionView from '../backbone/views/checkout/redemption_view';
import PaymentMethodCollection from '../backbone/models/PaymentMethodCollection';
import PriceModel from '../backbone/models/PriceModel';
import RelationshipModel from '../backbone/models/RelationshipModel';
import RoverBucksModel from '../backbone/models/RoverBucksModel';
import PaymentModel from '../backbone/models/PaymentModel';

$(() => {
  if (!$('body.js-checkout').length) {
    return;
  }

  let confirmationShown = false;
  let requestableModel = false;
  let summaryView = false;
  // eslint-disable-next-line no-unused-vars
  let optionalRequesterAddOnsListView = false;
  let creditCardCollection = false;
  let creditCardCollectionView = false;
  let paymentModel = false;
  let priceModel = false;
  let relationshipModel = false;
  let roverBucksModel = false;
  let serviceModel = false;
  let errorMessage = null;
  let unmountReactCCForm;
  let setDisabledReactCCFormUI;

  const hideCreditCardInput = () => {
    if (!creditCardCollection.length) {
      $('.js-creditcard-section').hide();
    }

    $('.js-authorize-text').hide();
    $('.js-creditcard:checked').prop('checked', false);
    $('.js-creditcard, .js-remove-cc').prop('disabled', true);
    $('.js-creditcard-list').addClass('disabled');
    $('.js-payment-alerts-container').empty();
    Alerts.showToast({
      severity: 'info',
      message: i18n._('Good news! Your Rover credit covers the cost of this booking.'),
      container: $('.js-payment-alerts-container'),
      showHideButton: false,
    });
    if (setDisabledReactCCFormUI) {
      setDisabledReactCCFormUI();
    }
  };

  const showCreditCardInput = () => {
    $('.js-payment-alerts-container').empty();
    $('.js-creditcard, .js-remove-cc').prop('disabled', false);
    $('.js-creditcard-section').show();
    $('.js-authorize-text').show();

    if (creditCardCollection.length) {
      $('.js-creditcard.js-default-payment').prop('checked', true);
      $('.js-creditcard-list')
        .removeClass('disabled')
        .show();
    } else if (Rover.context.hasPaidWithPaypal) {
      Alerts.showToast({
        severity: 'warning',
        message: i18n._(
          'We no longer support Paypal for sending payment to your sitter. Please add a credit or debit card.'
        ),
        container: $('.js-payment-alerts-container'),
      });
    }
  };

  const showMainContainer = () => {
    $('.js-main-container').removeClass('padding-x8 rover-loading');
    $('[data-toggle="popover"]').popover();
  };

  /**
   * @param paymentState
   */
  const showConfirmation = () => {
    if (confirmationShown) {
      return;
    }
    confirmationShown = true;

    new ConfirmationView({
      requestableModel,
      relationshipModel,
      el: '.js-confirmation',
      showCallback: showMainContainer,
    }).render();

    Rover.utils.scrollTo('.js-main-container');
  };

  const shouldShowPayments = () => requestableModel.isPayingState();

  /**
   * We can choose if we show credit card input or now as soon as we know
   * the roverbucks you have, your credit cards have been rendered, and the
   * conversation has been rendered
   *
   * @param initial
   */
  const setInputsState = () => {
    if (!shouldShowPayments()) {
      return;
    }

    if (!roverBucksModel) {
      return;
    }

    const roverBucks = roverBucksModel.get('non_redeemable');
    const creditCardsRendered = creditCardCollectionView.isRendered() === true;
    const conversationRendered = summaryView.isRendered() === true;

    if (roverBucks !== null && creditCardsRendered && conversationRendered) {
      if (!priceModel.roverBucksCoverCost()) {
        showCreditCardInput();
      } else {
        hideCreditCardInput();
      }
      $('.js-payment-methods').show();
      showMainContainer();
    }
  };

  const setInputsStateInitial = () => {
    setInputsState(true);

    const state = requestableModel.getState();

    if (state === 'authorize') {
      $('.js-submit')
        .text(i18n._('Request to Book'))
        .attr('data-loading-text', i18n._('Loading...'));
      $('.js-authorize-text').show();
    } else if (state === 'pay') {
      $('.js-submit')
        .text(i18n._('Pay Now'))
        .attr('data-loading-text', i18n._('Loading...'));
      $('.js-authorize-text').hide();
    }
  };

  const canProceed = () => {
    const selectedCreditCard = $('.js-creditcard:checked').length;
    const payingEntirelyWithRoverbucks = priceModel.roverBucksCoverCost();
    const showSubmit = selectedCreditCard || payingEntirelyWithRoverbucks;
    $('.js-submit').prop('disabled', !showSubmit);
  };

  const resetState = () => $('.js-submit').prop('disabled', true);

  const getEventDataFromRequestable = model => {
    const pets = model.get('pets');
    const petTypes = pets && pets.length > 0 ? _.uniq([].concat(...pets.map(p => p.pet_type))) : [];
    const petBreeds = pets && pets.length > 0 ? _.uniq([].concat(...pets.map(p => p.breeds))) : [];

    return {
      dropOffDate: model.getDatesData().start_date,
      pickUpDate: model.getDatesData().end_date,
      service_type: model.getServiceType().slug,
      pet_type: petTypes.length > 1 ? 'both' : petTypes[0],
      pet_breeds: petBreeds.join(','),
      zipCode: currentUser ? currentUser.zip : undefined,
    };
  };

  const fireBookingCreatedMobileEmbedded = eventDataFromRequestable => {
    const facebookEvent = 'fb_mobile_purchase';
    const isNewCustomer = currentUser ? currentUser.is_new_customer : false;
    const kochavaEvent = isNewCustomer ? 'New Booking' : 'Repeat Booking';
    const firebaseEvent = isNewCustomer ? 'purchase' : 'spend_credits';
    const branchEvent = isNewCustomer ? 'PURCHASE' : 'SPEND_CREDITS';

    const eventNames = {
      facebook_event: facebookEvent,
      kochava_event: kochavaEvent,
      firebase_event: firebaseEvent,
      branch_event: branchEvent,
    };

    const eventData = {
      ...eventDataFromRequestable,
      isNewCustomer,
    };

    fireEmbeddedWebEvent({ eventData, eventNames });
  };

  const fireAchievementsMobileEmbedded = (data, eventDataFromRequestable) => {
    const firebaseEvent = {
      1: 'achieve_level',
      3: 'unlock_achievement',
    }[data.provider_booking_count];

    const branchEvent = {
      1: 'ACHIEVE_LEVEL',
      3: 'UNLOCK_ACHIEVEMENT',
    }[data.provider_booking_count];

    if (firebaseEvent && branchEvent) {
      const eventNames = {
        firebase_event: firebaseEvent,
        branch_event: branchEvent,
      };
      const eventData = eventDataFromRequestable;
      fireEmbeddedWebEvent({ eventNames, eventData });
    }
  };

  const handlePaymentSuccess = (model, data, options) => {
    const state = requestableModel.getState();
    const eventDataFromRequestable = getEventDataFromRequestable(requestableModel);

    if (state === 'authorize') {
      dataLayer.push({
        event: 'owner-conversion-checkout-request-book',
        submitStatus: 'success',
        conversationId: requestableModel.getOpk(),
        is_new_customer: currentUser ? currentUser.is_new_customer : undefined,
        ...eventDataFromRequestable,
      });
    } else if (state === 'pay') {
      dataLayer.push({
        event: 'owner-conversion-checkout-pay-now',
        submitStatus: 'success',
        conversationId: requestableModel.getOpk(),
        is_new_customer: currentUser ? currentUser.is_new_customer : undefined,
        ...eventDataFromRequestable,
      });
    }

    // Fire Create Booking event via postMessage for mobile embedded
    if (isMobileEmbedded()) {
      fireBookingCreatedMobileEmbedded(eventDataFromRequestable);
      fireAchievementsMobileEmbedded(data, eventDataFromRequestable);
    }

    // if the response contains a tracking URL, insert its contents in an iframe
    const trackingUrl = options.xhr.getResponseHeader('X-Rover-Event-Tracking-URL');
    if (trackingUrl) {
      const $iframe = $(`<iframe name="booking-tracking" src="${trackingUrl}"></iframe>`);
      $iframe.appendTo($('body'));
    }

    requestableModel.set(data);
    requestableModel.trigger('paid');
  };

  const showPaymentError = error => {
    Alerts.showToast({
      severity: 'danger',
      message: error,
      container: $('.js-payment-alerts-container'),
    });
    Rover.utils.scrollTo('.js-payment-alerts-container');
  };

  const submitPaymentErrorEvent = () => {
    const state = requestableModel.getState();

    if (state === 'authorize') {
      dataLayer.push({
        event: 'owner-conversion-checkout-request-book',
        submitStatus: 'fail',
        serviceType: requestableModel.getServiceType().slug,
        conversationId: requestableModel.getOpk(),
      });
    } else if (state === 'pay') {
      dataLayer.push({
        event: 'owner-conversion-checkout-transaction',
        serviceType: requestableModel.getServiceType().slug,
        conversationId: requestableModel.getOpk(),
        revenue: requestableModel.get('total_price'),
      });
      dataLayer.push({
        event: 'owner-conversion-checkout-pay-now',
        submitStatus: 'fail',
        serviceType: requestableModel.getServiceType().slug,
        conversationId: requestableModel.getOpk(),
      });
    }
  };

  const getDefaultErrorMessage = () =>
    i18n._(
      /* i18n: {0} is a phone number */
      t`There was an error submitting your request - please try again. If you continue to have issues, contact customer support at ${Rover.context.customerSupportPhone}.`
    );

  const handlePaymentError = (model, response) => {
    submitPaymentErrorEvent();
    const { responseJSON } = response;
    errorMessage = responseJSON.error_description || getDefaultErrorMessage();
    const nonFieldErrors = responseJSON.non_field_errors || [];

    if (response.status === 409) {
      errorMessage = i18n._(
        'It seems that the conversation was updated in the meantime. We reloaded the latest state of the conversation. Please review the "Stay Summary" section on the right and try again.'
      );

      requestableModel.fetch().done(() => {
        $('.js-submit').btn('reset');
        setInputsStateInitial();
        showPaymentError(errorMessage);
      });
    } else if (
      response.status === 400 &&
      nonFieldErrors.includes('start_date cannot be in the past')
    ) {
      errorMessage = i18n._(
        'This conversation has a start date in the past. It will need to be changed before it can be booked.'
      );
      showPaymentError(errorMessage);
    } else if (
      response.status === 400 &&
      responseJSON.error_type === 'conversation_missing_location'
    ) {
      errorMessage = nonFieldErrors[0] || errorMessage;
      showPaymentError(errorMessage);
    } else {
      $('.js-submit').btn('reset');
      showPaymentError(errorMessage);
    }
  };

  const handlePaymentIntentError = message => {
    submitPaymentErrorEvent();
    $('.js-submit').btn('reset');
    showPaymentError(message || getDefaultErrorMessage());
  };

  const makePayment = () =>
    paymentModel.pay({
      success: handlePaymentSuccess,
      error: handlePaymentError,
      // use a separate method instead of piggyback on handlePaymentError
      // since it has specific signature of Backbone model
      paymentIntentError: handlePaymentIntentError,
    });

  const handleSubmit = () => {
    $('.js-submit').btn('loading');
    $('.js-payment-alerts-container').empty();

    // If you are paying entirely with Rover Bucks and you have no
    // credit cards on files
    if (priceModel.roverBucksCoverCost() && creditCardCollection.models.length === 0) {
      $('.js-select-payment-method').fadeOut('fast', () => {
        $('.js-needs-cc').fadeIn('fast');
      });

      if (unmountReactCCForm) {
        unmountReactCCForm();
      }
      unmountReactCCForm = mountConversationsCheckoutPage(
        {
          onAddOrRemoveCard: () => makePayment(),
          serviceType: requestableModel.getServiceType().slug,
        },
        '#react-add-ccform'
      );
    } else {
      makePayment();
    }
  };

  let initPaymentsHasRun = false;

  const initPayments = () => {
    if (initPaymentsHasRun) {
      return;
    }
    initPaymentsHasRun = true;

    creditCardCollection = new CreditCardCollection();

    creditCardCollectionView = new CreditCardCollectionView({
      collection: creditCardCollection,
      el: '.js-creditcard-list-container',
    });

    priceModel.on('change', setInputsState);
    priceModel.on('change', canProceed);

    const paymentMethodCollection = new PaymentMethodCollection({
      creditCardCollection,
      roverBucksModel,
    });

    // attempt to mount react ccform
    unmountReactCCForm = mountConversationsCheckoutPage({
      onAddOrRemoveCard: () => paymentMethodCollection.fetch({ reset: true }),
      recieveSetDisabledReactCCFormUIFunc: func => (setDisabledReactCCFormUI = func),
      serviceType: requestableModel.getServiceType().slug,
    });

    paymentMethodCollection.fetch().then(canProceed);

    new RedemptionView({
      el: '.js-redemption-container',
      roverBucksModel,
      paymentMethodCollection,
    }).render();

    paymentModel = new PaymentModel({
      roverBucksModel,
      requestableModel,
      priceModel,
      creditCardCollectionView,
    });

    creditCardCollectionView.on('initialRender', setInputsStateInitial);
    creditCardCollectionView.on('initialRender', canProceed);
    creditCardCollectionView.on('rendered', canProceed);
    creditCardCollection.on('add', setInputsState);
  };

  const setMainPaneState = () => {
    const state = requestableModel.getState();

    if (shouldShowPayments()) {
      initPayments();
      dataLayer.push({
        event: 'purchase-intent',
      });
    } else if (['requested', 'booked'].indexOf(state) !== -1) {
      showConfirmation(state);
    } else {
      window.location = requestableModel.get('web_url');
    }

    setInputsStateInitial();

    // Tell native webviews they can close the loading indicator
    if (
      window.webkit &&
      window.webkit.messageHandlers &&
      window.webkit.messageHandlers.rover &&
      window.webkit.messageHandlers.rover.postMessage
    ) {
      window.webkit.messageHandlers.rover.postMessage({
        action: 'hide-loading-indicator',
      });
    } else {
      $(document).trigger('hide-loading-indicator');
    }
  };

  const addBindings = () => {
    requestableModel.on('complete paid', setMainPaneState);

    $('.js-creditcard').on('change', canProceed);

    $('.js-submit').on('click', handleSubmit);
  };

  const initHighlightCancellationMessageOnScroll = () => {
    const $el = $('.js-cancellation-message');
    if (!$el.length) return;

    // eslint-disable-next-line no-unused-vars
    const scrollHandler = new ScrollTrigger(
      {
        $element: $el,
        offset: 50,
      },
      () => {
        $el.addClass('remove-highlight');
      }
    );
  };

  const init = () => {
    let SummaryView;
    resetState();

    if (Rover.context.requestableType === 'recurring-billing') {
      requestableModel = new Rover.models.RecurringBillingModel({
        url: Rover.urls.recurringBillingDetail,
      });
      SummaryView = RecurringBillingSummaryView;
    } else {
      requestableModel = new ConversationModel({
        url: Rover.urls.conversationDetail,
      });
      SummaryView = ConversationView;
    }

    roverBucksModel = new RoverBucksModel();

    priceModel = new PriceModel({
      requestableModel,
      roverBucksModel,
    });

    summaryView = new SummaryView({
      model: requestableModel,
      priceModel,
      el: '.js-conversation-summary',
    });

    optionalRequesterAddOnsListView = new OptionalRequesterAddOnsListView({
      requestableModel,
      el: '.js-requester-add-ons-container',
    });
    requestableModel.on('changing:requester_add_ons', (slug, value) => {
      if (value) {
        canProceed();
      } else {
        $('.js-submit').attr('disabled', value);
      }
    });

    addBindings();

    const conversationDeferred = $.Deferred();
    requestableModel.fetch({
      success() {
        relationshipModel = new RelationshipModel(requestableModel.getRelationship());
        conversationDeferred.resolve();
      },
      error(model) {
        // eslint-disable-next-line no-param-reassign
        model.fetchFailed = true;
        conversationDeferred.resolve();
      },
    });

    serviceModel = new Rover.models.ServiceModel({
      url: Rover.urls.serviceDetail,
    });
    requestableModel.set('serviceModel', serviceModel);

    const serviceDeferred = $.Deferred();
    serviceModel.fetch({
      error(model) {
        // eslint-disable-next-line no-param-reassign
        model.fetchFailed = true;
        serviceDeferred.resolve();
      },
      success: serviceDeferred.resolve,
    });

    // eslint-disable-next-line consistent-return
    $.when(conversationDeferred.promise(), serviceDeferred.promise()).always(() => {
      // If both models have data fire the complete event
      if (!requestableModel.fetchFailed && !serviceModel.fetchFailed) {
        return requestableModel.trigger('complete');
      }

      // If the conversation model succeeded, is in the booked state, and
      // the service model failed, unset serviceModel from the
      // conversation and continue on.
      if (
        !requestableModel.fetchFailed &&
        serviceModel.fetchFailed &&
        requestableModel.isBooked()
      ) {
        requestableModel.unset('serviceModel');
        return requestableModel.trigger('complete');
      }
    });

    Rover.stickyPopover($('[data-toggle="sticky-popover"]'), {
      container: 'body',
    });

    initHighlightCancellationMessageOnScroll();
  };

  init();
});



// WEBPACK FOOTER //
// ./js/pages/checkout.js